import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { NamedRef } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

const { institutionAdmin } = appStrings.modules.coachingDashboard;

const labelFor = (ref: NamedRef, fromId: (id: number) => string): string => {
  if (ref.name !== null) return ref.name;

  return ref.id === null ? institutionAdmin.missingValue : fromId(ref.id);
};

export const institutionLabel = (ref: NamedRef): string => labelFor(ref, institutionAdmin.unnamed);

export const offeringLabel = (ref: NamedRef): string =>
  labelFor(ref, institutionAdmin.unnamedOffering);

export const cohortLabel = (ref: NamedRef): string => labelFor(ref, institutionAdmin.unnamedCohort);

export const orMissing = (value: string | null): string => value ?? institutionAdmin.missingValue;
